import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslocoService } from '@ngneat/transloco';
import { TaskSearch } from '../../modules/admin/tasks/tasks.types';
import { NextServicio } from '../../modules/admin/services/services.types';
import { ServicesService } from '../../modules/admin/services/services.service';
import { FuseConfirmationService } from '../../../@fuse/services/confirmation/confirmation.service';

@Component({
    selector: 'app-more-info-events-dialog',
    templateUrl: './more-info-events-dialog.component.html',
    styles: [
        /* language=SCSS */
        `
            .eventsMoreInfo-grid {
                grid-template-columns: 150px 150px 150px 150px 150px 150px;

                @screen sm {
                    grid-template-columns: 150px 150px 150px 150px 150px 150px;
                }

                @screen md {
                    grid-template-columns: 150px 150px 150px 150px 150px 150px;
                }

                @screen lg {
                    grid-template-columns: 150px 150px 150px 150px 150px 150px;
                }
                @screen xl {
                    grid-template-columns: 200px 200px 200px 200px 200px 200px;
                }
                @screen 2xl {
                    grid-template-columns: 222px 222px 222px 222px 222px 222px;
                }
                @screen 3xl {
                    grid-template-columns: 222px 222px 222px 222px 222px 222px;
                }
            }
        `
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MoreInfoEventsDialogComponent {

    eventsInfo: {}[] = [];
    task: TaskSearch;
    service: NextServicio;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
           task: TaskSearch,
           service: NextServicio,
        },
        public dialogRef: MatDialogRef<MoreInfoEventsDialogComponent>,
        private servicesService: ServicesService,
        private _fuseConfirmationService: FuseConfirmationService,
        private transloco: TranslocoService,
    ) { }

     /**
     * On init
     */
      ngOnInit() {
        this.task = this.data.task;
        this.service = this.data.service;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    closeDialog() {
        this.dialogRef.close();
    }

}
